/*
 * Form
 */
import RooForm from './Form';
import FieldConsumer from './Field';
import FieldArray from './FieldArray';
RooForm.Field = FieldConsumer;
RooForm.field = FieldConsumer;
RooForm.FieldArray = FieldArray;
export var Field = FieldConsumer;
export * from './interface';
export default RooForm;